class StoreDrawer extends HTMLElement {
  connectedCallback() {
    this.openButtons = document.querySelectorAll('[data-open-store-drawer]');
    this.closeButtons = this.querySelectorAll('[data-close-store-drawer]');

    this.openButtons.forEach((btn) =>
      btn.addEventListener('click', () => this.open()),
    );

    this.closeButtons.forEach((btn) =>
      btn.addEventListener('click', () => this.close()),
    );

    document.addEventListener('keydown', (e) => {
      if (e.key === 'Escape') this.close();
    });
  }

  open() {
    this.hidden = false;
    this.setAttribute('open', '');
    document.documentElement.setAttribute('scroll-lock', '');

    this._aria(true);
  }

  close() {
    this.hidden = true;
    this.removeAttribute('open');
    document.documentElement.removeAttribute('scroll-lock');

    this._aria(false);
  }

  _aria(state) {
    this.openButtons.forEach((btn) =>
      btn.setAttribute('aria-expanded', state ? 'true' : 'false'),
    );
  }
}

if (!customElements.get('store-drawer')) {
  customElements.define('store-drawer', StoreDrawer);
}
